import { ButtonIcon, ButtonIconShape, ButtonIconWeight } from 'presentation/ui/partials/button/button-icon/ButtonIcon';
import { IconIdentifier } from 'presentation/ui/partials/icon/IconIdentifier';
import { FunctionComponent, useContext } from 'react';
import { AuthContext } from '../../../../../../services/core/context/AuthContext';
import { Permission } from '../../../../../../services/core/lib/auth/AuthService';

import './card-maintenance-log-list.scss';

type CardDocumentButton = {
	icon: IconIdentifier,
	disabled: boolean;
	onClick: (cardId: string) => void;
};

export interface CardMaintenanceLogListProps {
	/**
	 * Id of controlled card
	 */
	cardId: string;
	/**
	 * (Optional) Button props
	 */
	button?: CardDocumentButton;
}

/**
 * The document card component
 */
export const CardMaintenanceLogList: FunctionComponent<CardMaintenanceLogListProps> = (props): JSX.Element => {
	const { button, cardId, children } = props;

	const authContext = useContext(AuthContext);

	const buttonEl = button ?
		<ButtonIcon
			icon={button.icon}
			shape={ButtonIconShape.RECTANGLE}
			weight={ButtonIconWeight.PRIMARY}
			disabled={button.disabled || !authContext.hasPermission(Permission.MAINTENANCE_LOG_ENTRY_UPDATE)}
			onClick={() => button.onClick(cardId)}
		/> :
		null;

	return (
		<div className='card-maintenance-log-list'>
			<div className='card-maintenance-log-list__content'>
				{children}
			</div>

			{buttonEl}
		</div>
	);
};
